import {useCallback, useEffect, useState} from "react";


export default function usePaginator(name: string, sortDefault: Record<string, string>) {
    const key = "paginator_" + name
    const data = localStorage.getItem(key)
    const first = Object.keys(sortDefault).pop()
    let defaults: {
        page: number,
        sortField: string,
        sortDirection: "asc" | "desc",
        filter: string,
    } = {
        page: 1,
        sortField: first || "name",
        sortDirection: "asc",
        filter: ""
    }
    if (data) {
        defaults = {...defaults, ...JSON.parse(data)}
    }


    const [filter, setFilter] = useState<string>(defaults.filter);
    const [page, setPage] = useState(defaults.page);
    const [sortField, setSortField] = useState(defaults.sortField);
    const [sortDirection, setSortDirection] = useState<"asc" | "desc">(defaults.sortDirection);

    const [debouncedValue, setDebouncedValue] = useState(defaults.filter);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(filter);
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [filter]);

    const setFilterWrapper = useCallback((val: string) => {
        console.trace("filter wrapper", val)
        setFilter(val);
        setPage(1)
    }, [])
    useEffect(() => {
        localStorage.setItem(key, JSON.stringify({filter, page, sortField, sortDirection}));
    }, [filter, page, sortField, sortDirection])
    return {
        filter,
        debouncedFilter: debouncedValue,
        setFilter: setFilterWrapper,
        page,
        setPage,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection
    }
}


